module.exports = {
	"pagination": {
		"DescribeStream": {
			"input_token": "ExclusiveStartShardId",
			"limit_key": "Limit",
			"more_results": "StreamDescription.HasMoreShards",
			"output_token": "StreamDescription.Shards[-1].ShardId",
			"result_key": "StreamDescription.Shards"
		},
		"ListStreams": {
			"input_token": "ExclusiveStartStreamName",
			"limit_key": "Limit",
			"more_results": "HasMoreStreams",
			"output_token": "StreamNames[-1]",
			"result_key": "StreamNames"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesis-2013-12-02.paginators.json
// module id = 710
// module chunks = 2